"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetReviewReportHistoryParams () {
        return GetReviewReportHistoryParams;
    },
    get GetReviewReportHistoryResponse () {
        return GetReviewReportHistoryResponse;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _utilsisomorphic = require("@performyard/utils-isomorphic");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const GetReviewReportHistoryParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const ReviewReportHistoryAction = _zod.default.enum([
    "submit",
    "save",
    "edit",
    "sign-off",
    "send-back",
    "send-invite",
    "reopen",
    "close"
]);
const ReviewReportHistoryEditsResponse = _zod.default.object({
    authors: _zod.default.array(_zod.default.string().nullable()).optional(),
    signers: _zod.default.array(_zod.default.string().nullable()).optional(),
    visible: _zod.default.boolean().optional(),
    redacted: _zod.default.boolean().optional(),
    authors_due_date: _zod.default.date().optional(),
    signers_due_date: _zod.default.date().optional()
});
const ReviewReportHistoryItem = _zod.default.object({
    _id: _utilsisomorphic.transformObjectId,
    action: ReviewReportHistoryAction,
    actor: _utilsisomorphic.transformObjectId,
    actor_name: _zod.default.string(),
    timestamp: _zod.default.date(),
    comment: _zod.default.string().optional(),
    receiver_name: _zod.default.string().optional(),
    receiver_action: _zod.default.enum([
        "edit",
        "sign"
    ]).optional(),
    edits: ReviewReportHistoryEditsResponse.optional()
});
const GetReviewReportHistoryResponse = _zod.default.object({
    data: _zod.default.array(ReviewReportHistoryItem),
    meta: _zod.default.object({
        success: _zod.default.literal(true)
    })
});
